module.exports = __webpack_public_path__ + "static/img/office4.b84eddf.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/office/office4.png
// module id = Z8ZB
// module chunks = 1